
let config = {
    "origin" : "https://www.lesglandus.fr"
}

export default config;